export const friendInfo = {
    en: 'friends',
    ru: 'друзей'
}
